import { API_BASE } from '@/shared/services/api';
import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

export const Slide1 = ({ t }) => (
  <section className="hero-bg pad-sm min-h-screen flex items-center justify-center">
    <div className="wrap">
      <div className="grid">
        <div className="reveal in">
          <div className="eyebrow">{t?.eyebrow}</div>
          <h1 className="serif display" data-testid="hero-title" dangerouslySetInnerHTML={{ __html: t?.title }}></h1>
          <p className="lead">{t?.lead}</p>
          <div className="cta-actions flex flex-wrap items-center gap-3">
            <button onClick={() => document.querySelector('[data-slide-index="1"]')?.scrollIntoView({ behavior: 'smooth' })} className="pill" data-testid="hero-cta-explore">{t?.cta_explore}</button>
            <button onClick={() => document.querySelector('[data-slide-index="7"]')?.scrollIntoView({ behavior: 'smooth' })} className="btn-ghost" data-testid="hero-cta-contact">{t?.cta_contact}</button>
            <button onClick={() => document.querySelector('[data-slide-index="7"]')?.scrollIntoView({ behavior: 'smooth' })} className="pill">Request a Meeting →</button>
          </div>
          <div className="badges mt-6">
            {t?.badges && typeof t.badges === 'string' ? JSON.parse(t.badges).map((b, i) => <span key={i} className="badge">{b}</span>) : t?.badges?.map((b, i) => <span key={i} className="badge">{b}</span>)}
          </div>
        </div>
        <div className="hero-img reveal in" data-testid="hero-image">
          <img src="/images/ezerp/hero.png" alt="EzERP dashboard over warehouse" />
        </div>
      </div>
    </div>
  </section>
);

export const Slide2 = ({ t }) => {
  const features = t?.features && typeof t.features === 'string' ? JSON.parse(t.features) : t?.features;
  return (
  <section className="pad min-h-screen flex items-center justify-center">
    <div className="wrap">
      <div className="two">
        <div className="reveal in">
          <div className="eyebrow">{t?.eyebrow}</div>
          <h2 className="serif title">{t?.title}</h2>
          <p className="lead">{t?.lead}</p>
          <ul className="features" data-testid="overview-features">
            {features?.map((f, i) => <li key={i}>{f}</li>)}
          </ul>
        </div>
        <div className="art reveal in"><img src="/images/ezerp/warehouse.png" alt="EzERP warehouse operations" /></div>
      </div>
    </div>
  </section>
)};

export const Slide3 = ({ t }) => {
  const steps = t?.steps && typeof t.steps === 'string' ? JSON.parse(t.steps) : t?.steps;
  return (
  <section className="pad min-h-screen flex flex-col justify-center" style={{background:'var(--bg-2)'}}>
    <div className="wrap">
      <div className="sec-head reveal in">
        <div className="kicker">
          <div className="eyebrow">{t?.eyebrow}</div>
          <h2 className="serif title">{t?.title}</h2>
        </div>
      </div>

      <div className="team">
        <div className="pcard reveal in" data-testid="team-founder">
          <div className="avatar">TB</div>
          <div>
            <div className="role">{t?.tb_role}</div>
            <h3 className="serif">{t?.tb_name}</h3>
            <p>{t?.tb_desc}</p>
          </div>
        </div>
        <div className="pcard reveal in" data-testid="team-commercial">
          <div className="avatar" style={{background:'linear-gradient(135deg,#1f1f27,#3a2414)'}}>CT</div>
          <div>
            <div className="role">{t?.ct_role}</div>
            <h3 className="serif">{t?.ct_name}</h3>
            <p>{t?.ct_desc}</p>
          </div>
        </div>
      </div>

      <div className="steps" data-testid="team-steps">
        {steps?.map((s, i) => (
          <div key={i} className="step reveal in"><div className="scircle">{i + 1}</div><h4>{s.t}</h4><p>{s.d}</p></div>
        ))}
      </div>
    </div>
  </section>
)};

export const Slide4 = ({ t }) => {
  const marketingItems = [
    { t: "Web / SEO", d: "Website presence, content marketing and organic search visibility to attract inbound leads." },
    { t: "Social / LinkedIn", d: "LinkedIn campaigns, thought leadership and targeted social outreach to decision-makers." },
    { t: "Email / Outreach", d: "Outbound email prospecting, direct presentations and live demos to qualified accounts." },
    { t: "Partner Referrals", d: "Partner-led introductions, sales enablement materials and strategic media outreach." },
  ];
  const channelItems = [
    { t: "Direct Sales", d: "Direct account acquisition through outbound prospecting and relationship-led commercial selling." },
    { t: "Sales Agents", d: "Independent representatives and channel partners expanding commercial reach across segments." },
    { t: "Strategic Partners", d: "Commercial alliances, resellers and partner/channel-led entry into key client accounts." },
    { t: "Digital Lead Gen", d: "Module-first land-and-expand motion driven by digital inbound and demo conversion." },
  ];
  return (
    <section className="pad min-h-screen flex flex-col justify-center">
      <div className="wrap">
        <div className="sec-head reveal in">
          <div className="kicker">
            <div className="eyebrow">{t?.eyebrow}</div>
            <h2 className="serif title">{t?.title}</h2>
          </div>
        </div>

        <div className="two" style={{ marginBottom: '48px', alignItems: 'stretch', gridTemplateColumns: '1fr 1.35fr' }}>
          <div className="reveal in">
            <div className="gtm">
              <div className="infoblock" data-testid="gtm-marketing">
                <h3>{t?.gtm_title}</h3>
                {marketingItems.map((item, i) => (
                  <div key={i} className="item">
                    <h4>{item.t}</h4>
                    <p>{item.d}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="art reveal in" style={{ position: 'relative', minHeight: '520px' }}>
            <img src="/images/ezerp/marketing.png" alt="Marketing channels" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', transform: 'scale(1.5)', transformOrigin: 'center left' }} />
          </div>
        </div>

        <div className="cards" data-testid="gtm-channels">
          {channelItems.map((c, i) => (
            <div key={i} className="card reveal in">
              <div className="num">{i + 1}</div>
              <h4 className="serif">{c.t}</h4>
              <p>{c.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Slide5 = ({ t }) => {
  const stats = t?.stats && typeof t.stats === 'string' ? JSON.parse(t.stats) : t?.stats;
  const miles1 = t?.miles1 && typeof t.miles1 === 'string' ? JSON.parse(t.miles1) : t?.miles1;
  const miles2 = t?.miles2 && typeof t.miles2 === 'string' ? JSON.parse(t.miles2) : t?.miles2;
  return (
  <section className="pad min-h-screen flex flex-col justify-center" style={{background:'var(--bg-2)'}}>
    <div className="wrap">
      <div className="sec-head reveal in">
        <div className="kicker">
          <div className="eyebrow">{t?.eyebrow}</div>
          <h2 className="serif title">{t?.title}</h2>
        </div>
      </div>

      <div className="two" style={{alignItems:'stretch'}}>
        <div className="reveal in">
          <div className="stats" data-testid="year1-stats">
            {stats?.map((s, i) => (
              <div key={i} className="stat"><div className="big" style={s.v.includes('K') ? {fontSize:'28px'} : {}}>{s.v}</div><div className="sub">{s.t}</div><p>{s.d}</p></div>
            ))}
          </div>

          <div className="miles">
            <div className="infoblock reveal in">
              <h3>{t?.miles1_title}</h3>
              <ul className="features">
                {miles1?.map((m, i) => <li key={i}>{m}</li>)}
              </ul>
            </div>
            <div className="infoblock reveal in">
              <h3>{t?.miles2_title}</h3>
              <ul className="features">
                {miles2?.map((m, i) => <li key={i}>{m}</li>)}
              </ul>
            </div>
          </div>
        </div>
        <div className="art reveal in"><img src="/images/ezerp/growth.png" alt="Client acquisition and growth" style={{height:'100%',minHeight:'520px'}}/></div>
      </div>
    </div>
  </section>
)};

export const Slide6 = ({ t, lang }) => {
  const [view, setView] = useState('qtr');
  const [expanded, setExpanded] = useState(false);

  const rates = { en: { sym: 'US$', rate: 1 / 5.01 }, pt: { sym: 'R$', rate: 1 }, es: { sym: '€', rate: 0.85 / 5.01 } };
  const r = rates[lang] || rates['en'];
  const fmt = (v) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.round(v * r.rate));
  const fmtK = (v) => ((v * r.rate) / 1000).toFixed(1) + 'K';
  const sym = r.sym;

  const qtr = {
    cols: ['Line Item', 'Q1', 'Q2', 'Q3', 'Q4', 'Total'],
    clients:  [1, 6, 6, 6, 19],
    active:   [1, 7, 13, 19, 19],
    revenue:  [12500, 187500, 412500, 637500, 1250000],
    prodMkt:  [57500, 67500, 78000, 87000, 291000],
    sales:    [3750, 55000, 110000, 155625, 324375],
    totalExp: [61250, 122500, 188000, 242625, 614375],
    contrib:  [-48750, 65000, 224500, 394875, 635625],
    subs: [
      { label: 'Product & Platform Maintenance', vals: [36000, 36000, 36000, 36000, 144000] },
      { label: 'Hosting / Security / Licenses',  vals: [6000, 6000, 6000, 6000, 24000] },
      { label: 'Marketing / Content / Media',     vals: [6000, 9000, 12000, 15000, 42000] },
      { label: 'Admin / Legal / Finance',          vals: [4500, 4500, 6000, 6000, 21000] },
      { label: 'Travel / Demos / Onboarding',     vals: [3000, 6000, 9000, 12000, 30000] },
      { label: 'Customer Success / Support',       vals: [2000, 6000, 9000, 12000, 30000] },
    ],
    chartTitle: 'Quarterly Revenue vs Expenses',
    chartLegend: ['Revenue', 'Expenses'],
    xlabels: ['Q1', 'Q2', 'Q3', 'Q4'],
    barRev: [12500, 187500, 412500, 637500],
    barExp: [61250, 122500, 188000, 242625],
    barRevH: [2, 29, 65, 100],
    barExpH: [10, 19, 29, 38],
  };

  const mo = {
    cols: ['Line Item', 'Q1 (Mo 3)', 'Q2 (Mo 6)', 'Q3 (Mo 9)', 'Q4 (Mo 12)', 'Year-End Exit'],
    clients:  [1, 7, 13, 19, 19],
    active:   [1, 7, 13, 19, 19],
    revenue:  [12500, 87500, 162500, 237500, 237500],
    prodMkt:  [19167, 22500, 26000, 29000, 29000],
    sales:    [3750, 25000, 41875, 56875, 56875],
    totalExp: [22917, 47500, 67875, 85875, 85875],
    contrib:  [-10417, 40000, 94625, 151625, 151625],
    subs: [
      { label: 'Product & Platform Maintenance', vals: [12000, 12000, 12000, 12000, 12000] },
      { label: 'Hosting / Security / Licenses',  vals: [2000, 2000, 2000, 2000, 2000] },
      { label: 'Marketing / Content / Media',     vals: [2000, 3000, 4000, 5000, 5000] },
      { label: 'Admin / Legal / Finance',          vals: [1500, 1500, 2000, 2000, 2000] },
      { label: 'Travel / Demos / Onboarding',     vals: [1000, 2000, 3000, 4000, 4000] },
      { label: 'Customer Success / Support',       vals: [667, 2000, 3000, 4000, 4000] },
    ],
    chartTitle: 'MRR vs Monthly Burn',
    chartLegend: ['MRR', 'Monthly Burn'],
    xlabels: ['Mo 3', 'Mo 6', 'Mo 9', 'Mo 12'],
    barRev: [12500, 87500, 162500, 237500],
    barExp: [22917, 47500, 67875, 85875],
    barRevH: [5, 37, 68, 100],
    barExpH: [10, 20, 29, 36],
  };

  const d = view === 'qtr' ? qtr : mo;

  return (
    <section className="pad min-h-screen flex flex-col justify-center">
      <div className="wrap">
        <div className="sec-head reveal in">
          <div className="kicker">
            <div className="eyebrow">{t?.eyebrow}</div>
            <h2 className="serif title">{t?.title}</h2>
            <p className="lead">{t?.lead}</p>
          </div>
        </div>

        {/* Toggle Tabs */}
        <div className="fin-tabs reveal in">
          <button
            className={view === 'qtr' ? 'fin-tab active' : 'fin-tab'}
            onClick={() => setView('qtr')}
          >Qtr.</button>
          <button
            className={view === 'mo' ? 'fin-tab active' : 'fin-tab'}
            onClick={() => setView('mo')}
          >Monthly</button>
        </div>

        <div className="fin-layout reveal in">
          {/* LEFT — Financial Table */}
          <div className="fin-table-side">
            <table className="fintable" data-testid="financial-table">
              <thead>
                <tr>
                  {d.cols.map((c, i) => <th key={i}>{c}</th>)}
                </tr>
              </thead>
              <tbody>
                {/* Clients Added / Active */}
                <tr>
                  <td>{view === 'qtr' ? 'New Clients Added' : 'Active Clients'}</td>
                  {d.clients.map((v, i) => <td key={i}>{v}</td>)}
                </tr>
                {view === 'qtr' && (
                  <tr>
                    <td>Active Clients (End of Q)</td>
                    {d.active.map((v, i) => <td key={i}>{v}</td>)}
                  </tr>
                )}
                {/* Revenue */}
                <tr className="pos">
                  <td>{view === 'qtr' ? `Projected Recurring Revenue (${sym})` : `Monthly Recurring Revenue (${sym})`}</td>
                  {d.revenue.map((v, i) => <td key={i}>{fmt(v)}</td>)}
                </tr>
                {/* Product Mkt (expandable) */}
                <tr
                  style={{ cursor: 'pointer', background: 'rgba(255,255,255,0.02)' }}
                  onClick={() => setExpanded(!expanded)}
                >
                  <td style={{ color: '#e7e2d6' }}>
                    <span style={{ display: 'inline-block', width: '16px', color: 'var(--copper-2)', fontWeight: 'bold' }}>
                      {expanded ? '−' : '+'}
                    </span>{' '}
                    Product Mkt, Admin &amp; Platform Maintenance
                  </td>
                  {d.prodMkt.map((v, i) => <td key={i}>{fmt(v)}</td>)}
                </tr>
                {/* Expandable sub-rows */}
                {expanded && d.subs.map((sub, si) => (
                  <tr key={si} style={{ color: 'var(--muted)', fontSize: '0.92em', background: 'rgba(0,0,0,0.2)' }}>
                    <td style={{ paddingLeft: '36px' }}>• {sub.label}</td>
                    {sub.vals.map((v, i) => <td key={i}>{fmt(v)}</td>)}
                  </tr>
                ))}
                {/* Sales Commissions */}
                <tr>
                  <td>Sales Commissions (Level 1 + Master SR)</td>
                  {d.sales.map((v, i) => <td key={i}>{fmt(v)}</td>)}
                </tr>
                {/* Total Expenses */}
                <tr className="total">
                  <td>{view === 'qtr' ? `Total Projected Expenses (${sym})` : `Total Monthly Burn (${sym})`}</td>
                  {d.totalExp.map((v, i) => <td key={i}>{fmt(v)}</td>)}
                </tr>
                {/* Contribution */}
                <tr className="pos total">
                  <td>{view === 'qtr' ? `Projected Contribution After Expenses (${sym})` : `Monthly Contribution (MRR - Burn) (${sym})`}</td>
                  {d.contrib.map((v, i) => <td key={i}>{fmt(v)}</td>)}
                </tr>
              </tbody>
            </table>
            <p className="disclaimer">Scenario (B) / Scenario (C) — {view === 'qtr' ? 'Quarterly' : 'Monthly'} projections</p>
          </div>

          {/* RIGHT — Chart */}
          <div className="fin-chart-side">
            <div className="chart reveal in" data-testid="financial-chart">
              <div className="chart-head">
                <h3 className="serif" style={{ fontSize: '18px' }}>{d.chartTitle}</h3>
                <div className="legend">
                  <span><span className="swatch" style={{ background: 'linear-gradient(180deg,var(--copper-2),var(--rust))' }}></span>{d.chartLegend[0]}</span>
                  <span><span className="swatch" style={{ background: '#3a3a3e' }}></span>{d.chartLegend[1]}</span>
                </div>
              </div>
              <div className="bars">
                {d.barRev.map((_, i) => (
                  <div key={i} className="bargroup">
                    <div className="bar" style={{ height: d.barRevH[i] + '%' }}>
                      <span className="val">{fmtK(d.barRev[i])}</span>
                    </div>
                    <div className="bar exp" style={{ height: d.barExpH[i] + '%' }}>
                      <span className="val">{fmtK(d.barExp[i])}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="xlabels">
                {d.xlabels.map((l, i) => <div key={i}>{l}</div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Financial Narrative */}
        <div className="narr reveal in">
          <div>
            <h3 className="serif" style={{ fontSize: '22px' }}>Financial Narrative</h3>
            <p>EzERP's revenue model is fully recurring. With the first client closing in Month 3 and 2 new clients per month thereafter, the platform reaches positive contribution in Q2 and builds strong momentum through Q3–Q4.</p>
          </div>
          <div>
            <p>Total Year 1 projected contribution after expenses: <strong style={{ color: 'var(--copper-2)' }}>{sym} {fmt(875000)}</strong> — validating the unit economics and scalability of the recurring-revenue model.</p>
            <p className="disclaimer"><em>No setup fees modeled. Revenue upside available as onboarding fees are introduced.</em></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export const Slide7 = ({ t }) => {
  const strengths = t?.strengths && typeof t.strengths === 'string' ? JSON.parse(t.strengths) : t?.strengths;
  const cards = t?.cards && typeof t.cards === 'string' ? JSON.parse(t.cards) : t?.cards;
  const icons = ['◎', '◈', '◆'];
  return (
  <section className="pad min-h-screen flex flex-col justify-center" style={{background:'var(--bg-2)'}}>
    <div className="wrap">
      <div className="sec-head reveal in">
        <div className="kicker">
          <div className="eyebrow">{t?.eyebrow}</div>
          <h2 className="serif title">{t?.title}</h2>
        </div>
      </div>

      <div className="two" style={{alignItems:'flex-start'}}>
        <div className="reveal in strengths">
          <h3 className="serif" style={{fontSize:'24px',marginBottom:'14px'}}>{t?.strengths_title}</h3>
          <ul className="features" style={{columnCount:2, columnGap:'40px'}} data-testid="market-strengths">
            {strengths?.map((s, i) => <li key={i} style={{breakInside:'avoid'}}>{s}</li>)}
          </ul>
        </div>
        <div className="art reveal in"><img src="/images/ezerp/market.png" alt="Strategic market position" /></div>
      </div>

      <div className="mgrid">
        {cards?.map((c, i) => {
          const items = c.items && typeof c.items === 'string' ? JSON.parse(c.items) : c.items;
          return (
          <div key={i} className="mcard reveal in" data-testid={`market-card-${i}`}>
            <div className="mico">{icons[i]}</div>
            <h4>{c.t}</h4>
            <p>{c.d}</p>
            {items && (
              <ul>
                {items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            )}
          </div>
        );})}
      </div>

      <div className="adv reveal in" dangerouslySetInnerHTML={{ __html: t?.advantage }}></div>
    </div>
  </section>
)};

const BACKEND_URL = API_BASE || 'http://localhost:3001';

export const Slide8 = ({ t, lang }) => {
  const [formData, setFormData] = useState({ name: "", email: "", role: "business" });
  const [status, setStatus] = useState("idle");

  const submitForm = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${BACKEND_URL}/api/leads`, { ...formData, language: lang || "en", deck: "ezerp" });
      setStatus("success");
    } catch {
      setStatus("error");
      toast.error("Could not join waitlist");
    }
  };

  const labels = t?.labels && typeof t.labels === 'string' ? JSON.parse(t.labels) : (t?.labels || {});

  return (
    <section className="cta-bg pad min-h-screen flex flex-col justify-center">
      <div className="wrap">
        <div className="grid">
          <div className="reveal in">
            <div className="eyebrow">{t?.eyebrow}</div>
            <h2 className="serif" style={{marginTop:'12px', fontSize:'58px'}} dangerouslySetInnerHTML={{ __html: t?.title }}></h2>
            <p className="lead">{t?.lead}</p>
            
            {status === "success" ? (
              <div className="mt-10 p-8 rounded-2xl border border-[rgba(255,255,255,0.1)] glass-strong text-center animate-pop">
                <div className="mx-auto w-14 h-14 rounded-full bg-[var(--copper)] text-black flex items-center justify-center font-display text-2xl mb-6">
                  ✓
                </div>
                <div className="font-display text-3xl mb-3">{t?.success_title}</div>
                <div className="text-neutral-400">{t?.success_sub}</div>
              </div>
            ) : (
              <form onSubmit={submitForm} className="mt-10 p-8 rounded-2xl border border-[rgba(255,255,255,0.1)] glass-strong">
                <div className="font-display text-2xl mb-6">{t?.form_title}</div>
                <div className="space-y-4">
                  <div>
                    <label className="font-mono text-[10px] tracking-widest text-neutral-500 block mb-2">{labels.name}</label>
                    <input type="text" required className="dark-input w-full px-4 py-3 rounded-lg" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})}/>
                  </div>
                  <div>
                    <label className="font-mono text-[10px] tracking-widest text-neutral-500 block mb-2">{labels.email}</label>
                    <input type="email" required className="dark-input w-full px-4 py-3 rounded-lg" value={formData.email} onChange={e=>setFormData({...formData, email: e.target.value})}/>
                  </div>
                  <div>
                    <label className="font-mono text-[10px] tracking-widest text-neutral-500 block mb-2">{labels.role}</label>
                    <select className="dark-input w-full px-4 py-3 rounded-lg" value={formData.role} onChange={e=>setFormData({...formData, role: e.target.value})}>
                      <option value="business">{labels.biz}</option>
                      <option value="investor">{labels.inv}</option>
                    </select>
                  </div>
                  <button type="submit" disabled={status === "loading"} className="w-full bg-[var(--copper)] hover:bg-[var(--copper-2)] text-black font-medium py-3 rounded-lg transition-colors mt-2">
                    {status === "loading" ? labels.loading : labels.btn}
                  </button>
                </div>
              </form>
            )}
          </div>
          <div className="hero-img reveal in"><img src="/images/ezerp/cta.png" alt="EzERP open pipeline" style={{height:'440px'}}/></div>
        </div>
      </div>
    </section>
  );
};

